(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cap-country-selector')) {
    customElements.define('cap-country-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.countrySelectorReady) return;
        const select = this.querySelector('select[name="country_code"]');
        const form = this.querySelector('form');
        if (!select || !form) return;
        this.countrySelectorReady = true;
        select.addEventListener('change', () => {
          form.setAttribute('aria-busy', 'true');
          form.requestSubmit();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
